import { Building2 } from "lucide-react";
import { useCurrentUser } from "@/hooks/useCurrentUser";
import { SmplifyLogo } from "@/components/SmplifyLogo";
import { NotificationCenter } from "@/components/NotificationCenter";
import { UserMenu } from "@/components/UserMenu";

function greeting(): string {
  const h = new Date().getHours();
  if (h < 12) return "Good morning";
  if (h < 18) return "Good afternoon";
  return "Good evening";
}

export function MobileAppHeader({ org }: { org?: string }) {
  const { firstName } = useCurrentUser();

  return (
    <header className="flex items-center justify-between gap-3 px-4 pb-3 pt-3">
      <div className="min-w-0 flex-1">
        <p className="text-[11.5px] font-medium text-[color:var(--m-gray)]">
          {greeting()}, {firstName ?? "there"}
        </p>
        <div className="mt-0.5 flex items-center gap-1.5">
          <SmplifyLogo size="header" className="!h-9 md:!h-9" />
          {org && (
            <>
              <span className="text-[color:var(--m-gray-3)]">·</span>
              <span className="truncate text-[14px] font-semibold text-[color:var(--m-ink)]">
                {org}
              </span>
              <Building2
                className="h-3.5 w-3.5 text-[color:var(--m-gray-3)]"
                aria-hidden
              />
            </>
          )}
        </div>
      </div>
      <div className="flex shrink-0 items-center gap-1">
        <NotificationCenter />
        <UserMenu />
      </div>
    </header>
  );
}

export default MobileAppHeader;
